import api from '@/api';

import { ReportDiagnosticParams } from './Report.types';
import { API_BASE_URL } from './../../index';

const baseUrl = API_BASE_URL;

export async function generateDiagnosticReport(params: ReportDiagnosticParams) {
  const result = (await api.getReport(
    `${baseUrl}/generate/diagnostic`,
    params,
  )) as unknown;

  return result as BlobPart;
}
